const STRIPE_KEY = {
    development: 'pk_test_esXbbsc29bxQUyamvShdqPpW',
    test: 'pk_test_esXbbsc29bxQUyamvShdqPpW',
    production: 'pk_live_b0xvYBQPhFvCPzGsyW3KYtvE',
};

export default STRIPE_KEY[process.env.BUILD_ENV || process.env.REACT_APP_BUILD_ENV];
